import React, { Component } from 'react';

import { ArchetypeBox }	from './ArchetypeBox';
import { OffenseBox }		from './OffenseBox';
import { DefenseBox }		from './DefenseBox';
import { AdvancedBox }	 from './AdvancedBox';

import { CardSelectBox } from './CardSelectBox';

import { CreateBox } from './CreateBox';
import { DeckCard }	from './DeckCard';
import { Note }	from './Note';
import { Twitter } from './Twitter.js';


import { apiHost } from '../config.js';
import { Ad } from './Ad.js';
import { AdBabyDragon } from './AdBabyDragon.js';
import { AdNative } from './AdNative.js';
import { PatreonEBegging } from './PatreonEBegging.js';






//import { CardButton } from './CardButton';


import '../App.css';


let data = {};
class App extends Component {
	constructor(props) {
		super(props);
		this.state = {	value: '',
										card0: "legendary-unknown",
										card1: "legendary-unknown",
										card2: "legendary-unknown",
										card3: "legendary-unknown",
										card4: "legendary-unknown",
										card5: "legendary-unknown",
										card6: "legendary-unknown",
										card7: "legendary-unknown",
										fitness: "?",
										averageElixir: "?",
										deckLink:    "link.clashroyale.com/deck/en?deck=",
										warDeckLink: "link.clashroyale.com/deck/en?deck=",

										canClick: "",
										version: "0.6.21"
									};

		//this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	handleChange = (event) => {
		let debugTest = event.target.value;
		this.setState({value: event.target.value,
										debugTest: event.target.value
									});
		alert(this.state.value);
		alert(debugTest);
		alert(this.state);
	}

	handleSubmit(event) {
		alert("This is a test: " + this.state.value);
		event.preventDefault();
	}

	state = {
		response: ''
	};



	callApi = async (event) => {
		//event.preventDefault();

		/* const response = await fetch('/evolve', {
			method: 'POST',
			body: data
		});*/
		let serverCall;
		if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1"){
    	serverCall = "/evolve";
		} else {
			serverCall = "http://deckscalibur.us-east-1.elasticbeanstalk.com/evolve";
		}
		//When testing, use /evolve. In production, use deckscalibur.us-east-1
		const response = await fetch(serverCall, {

		//const response = await fetch('/evolve', { //This may need to be const response = await fetch(`${apiHost}/evolve`, { //But you'll have to change stuff in package.json.
			method: 'POST',
			body: JSON.stringify(data), // data can be `string` or {object}!
		  headers:{
		    'Content-Type': 'application/json'
			}
		});

		/*const response = postData(`/evolve`, {answer: 42})
		  .then(data => console.log(JSON.stringify(data))) // JSON-string from `response.json()` call
		  .catch(error => console.error(error));*/

		//const response = await fetch('/evolve');
		//let url = "/evolve";
		//let data = {username: "example"};
		//let body = {};
		/*const response = await fetch(url, {
		  method: 'POST', // or 'PUT'
		  body: JSON.stringify(data), // data can be `string` or {object}!
		  headers:{
		    'Content-Type': 'application/json'
			}
		}).then(res => res.json())
		//.then(response => console.log('Success:', JSON.stringify(response)))
		.then(response => console.log('Success:', response))
		.catch(error => console.error('Error:', error));*/
		//console.log(typeof await response);

		const body = await response.json();
		//const body = await JSON.stringify(response)
		//const body = await response;
		//const body = await JSON.parse(response);


		if (await response.status !== 200) throw Error(body.message);
		return body;
	};


	/*componentDidMount() {
		this.callApi()
			.then(res => this.setState({ response: res.express }))
			.catch(err => console.log(err));
	}*/


	handleCreateDeck = (event) => {
		this.setState({canClick: "unclickable"});
		//event.preventDefault();
		//console.log(event.target[0].value);
		//console.log(event.target[0].checked);
		//console.log(event.target.length);
		data = {};
		let settingsArray = [];
		let war = [];
		let require = [];
		let suggest = [];
		let ban = [];

		let numSettings = [0];
		let numWarRequirements = [0];
		let numRequirements = [0];
		let numSuggestions = [0];
		let numBans = [0];
		for (var i = 0; i < event.target.length; i++) { //Set the settings up to be sent.
			//console.log(event.target[i].value);
			let settingName = event.target[i].value;
			let checked = event.target[i].checked;
			//let element = {event.target[i].value:  event.target[i].checked}
			//data = Object.assign(element);
			//data[settingName] = checked;

			function addSettings(list, listString, numOfSettings){
				if (settingName.includes(listString)) {
					let removableIndicator = "." + listString;
					settingName = settingName.replace(removableIndicator, "");
					list.push(settingName);
					//list[numSettings[0]] = settingName;
					numOfSettings[0]++;
					return true; //tells the next if statement to stop going.
				} else {
					return false; //tells the next if statement to keep going.
				}
			}

			if (checked) { //Determine what array to put the setting in.
				if (addSettings(require, "require", numRequirements)) {
				} else if (addSettings(suggest, "suggest", numSuggestions)) {
				} else if (addSettings(ban, "ban", numBans)) {
				} else if (addSettings(war, "war", numWarRequirements)) {
				} else {
					settingsArray[numSettings[0]] = settingName;
					numSettings[0]++;
				}
			}
		}
		data["settings"] = settingsArray;
		data["war"] = war;
		data["require"] = require;
		data["suggest"] = suggest;
		data["ban"] = ban;


		//alert(event);
		this.callApi(event)
			.then(res => this.setState({ response: res.express,
																		card0: res.express[0],
																		card1: res.express[1],
																		card2: res.express[2],
																		card3: res.express[3],
																		card4: res.express[4],
																		card5: res.express[5],
																		card6: res.express[6],
																		card7: res.express[7],
																		backgroundCard: res.express[8],
																		fitness: res.express[9],
																		averageElixir: res.express[10],
																		deckLink: res.express[11],
																		warDeckLink: res.express[11] + "&war=1",
																	}))
			.catch(err => console.log(err));

		window.setTimeout(() => {this.setState({canClick: ""})}, 3000);
		event.preventDefault();
	}



	render() {
		return (
			<div className="App">
				<header className="App-header">
					<div className="HeaderBackground" />

					<div className="header-text">
						<h1 className="DeckscaliburTitle">Deckscalibur</h1>
						<h1 className="App-subtitle">An evolution simulator that makes strong decks for Supercell&#8217;s mobile game Clash Royale!
							<br/>
							version { this.state.version } - beta
						</h1>

					</div>

					<div className="LinkBoxDiv">
						<div className="LinkBoxDivInner">

							<p className="App-intro">
								<a href="./">Deck Builder</a>
							</p>

							{/*<div className="dividerLine" />*/}

							<p className="App-intro">
								<a href="./decksperiments">Decksperiments</a>
							</p>


							<p className="App-intro">
								<a href="./skilltree">Skill Tree</a>
							</p>


							<p className="App-intro">
								<a href="./about">About</a>
							</p>

						</div>
					</div>
				</header>

				<div className="PickFavorite">
					Pick your favorite archetypes and cards!
				</div>


				<form name="mainForm" className={"FormBox"} onSubmit={this.handleCreateDeck}>
					<div className="CardBoxCase">

						<div className="CardBoxColumn ArchetypeBoxOrder">
							<ArchetypeBox />
						</div>

						<div className="CardBoxColumn DoubleCardBox OffenseBoxOrder">
							<OffenseBox />
						</div>

						<div className="CardSelectBoxOrder">
						<CardSelectBox cardSelectType={ "require" } cardBackground="giant-skeleton" />
						</div>

						<div className="CardBoxColumn DefenseBoxOrder">
							<DefenseBox />
						</div>

						<div className="CardBoxColumn AdvancedBoxOrder">
							<AdvancedBox />
						</div>


						<div className="CardBoxColumn CreateBoxLabel CreateBoxOrder">
							<input	type="submit"
											name="sumbit"
											value="submit"
											id="submit"
											className="invisible"
							/>

							<label className={this.state.canClick}	htmlFor="submit">
								<CreateBox/>
							</label>




							<div className="deckBox">
								<div className="deckBoxTint" />
								<div className={ "deckBoxBackground " + this.state.backgroundCard } />

								<div className="deckArea">

									<DeckCard cardBackground={this.state.card0}/>
									<DeckCard cardBackground={this.state.card1}/>
									<DeckCard cardBackground={this.state.card2}/>
									<DeckCard cardBackground={this.state.card3}/>
									{/*
									<DeckCard cardBackground="soon"/>
									<DeckCard cardBackground="soon"/>
									<DeckCard cardBackground="soon"/>
									<DeckCard cardBackground={this.state.card7}/>
									*/}



									<DeckCard cardBackground={this.state.card4}/>
									<DeckCard cardBackground={this.state.card5}/>
									<DeckCard cardBackground={this.state.card6}/>
									<DeckCard cardBackground={this.state.card7}/>

								</div>

								<div className="descriptionBox">
									<div className="description">
										<div className="descriptionText">deckscalibur rating: {this.state.fitness}</div>
										<div className="descriptionTint" />
									</div>

									<div className="description">
										<div className="descriptionText">elixir: {this.state.averageElixir}</div>
										<div className="descriptionTint" />
									</div>

									{/*
									<div className="description">
										<div className="descriptionText">meta score: coming soon!</div>
										<div className="descriptionTint" />
									</div>

									<div className="description">
										<div className="descriptionText">anti-meta score: coming soon!</div>
										<div className="descriptionTint" />
									</div>


									<div className="description">
										<div className="descriptionText">archetypes: example, example</div>
										<div className="descriptionTint" />
									</div>
									*/}
									{/*
									<div className="description">
										<div className="descriptionText">control</div>
										<div className="descriptionTint" />
									</div>
									<div className="description">
										<div className="descriptionText">cycle</div>
										<div className="descriptionTint" />
									</div>

									<div className="description">
										<div className="descriptionText">ladder deck</div>
										<div className="descriptionTint" />
									</div>
									*/}

									{/*
									<div className="description">
										<div className="descriptionText">projected win rate: ???</div>
										<div className="descriptionTint" />
									</div>
								*/}

									<a href={ this.state.deckLink } target="_blank">
										<div className="description" >
											<div className="descriptionText">play!</div>
											<div className="descriptionTint" />
										</div>
									</a>

									<a href={ this.state.warDeckLink } target="_blank">
										<div className="description" >
											<div className="descriptionText">war!</div>
											<div className="descriptionTint" />
										</div>
									</a>

									<div className="version" >
										<div className="descriptionText"> v{ this.state.version}</div>
									</div>

								</div>
							</div>


						</div>

						<div className="CardBoxColumn AdBoxOrder">
							<PatreonEBegging />
						</div>
						{/*<div className="CardBoxColumn AdBoxOrder">
							<AdBabyDragon />
						</div>*/}

						{/*<div className="CardBoxColumn AdBoxOrder">
							<AdNative />
						</div>*/}

						<div className="CardBoxColumn NoteBoxOrder NoteBoxOrder">
							{/*<Ad />*/}
							<Note />
						</div>

						{/*<div className="CardBoxColumn">
							<Twitter />
						</div>*/}
					</div>




				</form>
				<div className="CardBoxCase">

				</div>




				<div className="CardBoxColumn bottomBox">
					<div className="bottomBoxColor" />
					<div className="bottomBoxTextBox">
						<p>
							If you like deckscalibur, follow us on <a href="https://twitter.com/deckscalibur">twitter</a>!
							If you love deckscalibur, join our community on <a href="https://discord.gg/etKuxTG">discord</a>!
							If you use to love deckscalibur, but not any more, you can pay child support here on <a href="https://www.patreon.com/bePatron?u=20686476" data-patreon-widget-type="become-patron-button">patreon</a><script async src="https://c6.patreon.com/becomePatronButton.bundle.js"></script>!
						</p>
					</div>
					<div className="bottomBoxTextBox">
						<p>
							This content is not affiliated with, endorsed, sponsored, or specifically approved by Supercell and Supercell is not responsible for it. For more information see <a href="http://www.supercell.com/fan-content-policy" target="_blank">Supercell’s Fan Content Policy</a>.
						</p>
					</div>
					<div className="bottomBoxTextBox">
						<p>
							Created by whyZaya (Gabriel Caterson) with some help from some pro players!<br />
							Personal best trophies: 6022. #PQLQQ8<br />
							Clan: BSG
							{/*For all business inquiries, email me at gabe@deckscalibur.com.*/}
						</p>
					</div>
				</div>


				{/*
				<form onSubmit={this.handleSubmit}>

					<div id="checkboxes">
						<input type="checkbox" name="archetype" value="1" id="r1" />
						<label className="whatever" htmlFor="r1"></label>
						<input type="checkbox" name="archetype" value="2" id="r2" />
						<label className="whatever" htmlFor="r2"></label>
						<input type="checkbox" name="archetype" value="3" id="r3" />
						<label className="whatever" htmlFor="r3"></label>
					</div>

					<label>
						Name:
						<input type="text" value={this.state.value} onChange={this.handleChange} />
					</label>
					<input type="submit" value="Submit" />
				</form>

				<div className="triangle-right" />
				*/}

			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/Components/App.js